import { FaEye, FaFileDownload } from 'react-icons/fa';


export const columnsDataInvoices = [
  {
    Header: "Tipo",
    accessor: "tipo_comprobante",
  },
  {
    Header: "Serie",
    accessor: "serie",
  },
  {
    Header: "Número",
    accessor: "numero",
  },
  {
    Header: "Fecha emisión",
    accessor: "fecha_emison",
  },
  {
    Header: "Receptor",
    accessor: "receptor.denominacion",
  },
  {
    Header: "Total",
    accessor: "totales.total",
  },
  {
    Header: "Estado",
    accessor: "estado_dgi.codigo",
  },
  {
    Header: '',
    accessor: 'actions',
    actions: [
      {
        label: 'Vista previa',
        icon: <FaEye />,
        colorScheme: 'teal',
        type: 'preview',
      },
      {
        label: 'Descargar PDF',
        icon: <FaFileDownload />,
        colorScheme: 'blue',
        type: 'download',
      },
    ],
  }
];
